import "../../chunk-BUSYA2B4.js";
import React from "react";
const useSafeLayoutEffect = typeof window !== "undefined" ? React.useLayoutEffect : React.useEffect;
export {
  useSafeLayoutEffect
};
//# sourceMappingURL=useSafeLayoutEffect.js.map